export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13467.82eef87c.jpg";